module.exports = __webpack_public_path__ + "img/linda-harris-reynolds.3e1d2a92.jpg";